import React, { Component } from 'react'

export default class componentName extends Component {
    constructor(props){
        super(props);
        this.state = {data:[{
            title:'更自然的量体体验',
            img:require('../image/youshi1.svg'),
            img01:require('../image/mengduo/p1.svg'),
            intro:[{
                sub:'衣着',
                intro01:'正常衣着的情况下，即可获取准确量体数据'},
                {
                sub:'姿态',
                intro01:'加入人体动态还原技术,在正常站姿下,即可完成量体'},
                {
                sub:'背景',
                intro01:'在复杂的背景,弱光情况下,也可完成拍照量体更广泛的应用场景'}
            ]},
            {
            title:'更广泛的应用场景',
            img:require('../image/youshi2.svg'),
            img01:require('../image/mengduo/p2.svg'),
            intro:[{
                sub:'准确',
                intro01:'行业领先的数据准确率，经过各行业应用检验'},
                {
                sub:'快速',
                intro01:'行业领先的数据准确率，经过各行业应用检验快速；对比传统量体方式，无需等待'},
                {
                sub:'方便',
                intro01:'提供云端、sdk、小程序、web等多种技术解决方案'}
            ]}
        ]};
    }
    render() {
        return (
            <div className="container2">
                <div className="title04">
                    <div className="titleAll">
                        <div className="title04-1" >我们的优势</div>
                        <div className="title04-2">/OUR ADVANTAGES</div>
                    </div>
                    <div className="title04-3">红创科技是中国最早用深度学习的方法展开人工智能应用研发的科技<br/>
                    公司之一,拥有行业领先的人体检测与识别、嵌入式系统开发技术、<br/>
                    云计算和大数据等核心技术.</div>
                </div>
                <div  className="box03">
                {
                    this.state.data.map((item)=>{
                     
                     return (
                        <div  className="box03-container">
                             <div className="box03-1" >
                                <img src={global.constants.channel==="mengduo"?item.img01:item.img} className="img-3"></img>
                                <div className="box03-2">
                                    <div className="title04-4">{item.title}</div>
                                </div>  
                        </div> 
                     {
                         item.intro.map((it)=>{
                             return (
                                    <div  className="box03-3">
                                        <div className="sub4">{it.sub}</div>
                                        <div className="intro-1">{it.intro01}</div>
                                    </div>
                                    )
                         })
                     }
                     </div>);
                    })
                 }
                </div>
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/fourth.js